export const ROLE_ACCESS = {
  admin:      ["dashboard","tickets","clients","devices","server-rmm","analytics","agents","settings","dev-tickets","infrastructure","knowledge-base","admin-review","client-database"],
  manager:    ["dashboard","tickets","clients","devices","server-rmm","analytics","agents","settings","dev-tickets","infrastructure","knowledge-base","client-database"],
  technician: ["dashboard","tickets","clients","devices","server-rmm","knowledge-base","client-database"],
  dev:        ["dashboard","tickets","server-rmm","dev-tickets","infrastructure","knowledge-base","client-database"],
  contact:    ["dashboard","tickets"],
};
